const mutations = {
  INIT_CONTENT_COMMENT_THREAD(state, contentId) {
    state.contentId = contentId;
  },
  SET_COMMENTS(state, { comments, totalComments, pages, page, reset = true }) {
    if (reset) {
      state.comments = comments;
    } else {
      state.comments.push(...comments)
    }
    state.totalComments = totalComments;
    state.pages = pages;
    state.currentPage = page;
  },
  SET_FEATURED_COMMENT(state, {comment}) {
    state.featuredComment = comment;
  },
  SET_PARTNER_COMMENTS(state, { comments}) {
    state.partnerComments = comments;
  },
  CLEAR_REPLYING_USER(state) {
    state.replyingUserId = null;
    state.replyingCommentId = null;
    state.replyingUserNick = null;
  },
  SET_REPLYING_USER(state, { userId, commentId, userNick }) {
    state.replyingUserId = userId; // not needed
    state.replyingCommentId = commentId;
    state.replyingUserNick = userNick;
  },
  SET_MUTED_USERS(state, { mutedUsers }) {
    state.mutedUsers = mutedUsers;
  },
  UPDATE_COMMENT_FILTERS(state, { filters }) {
    Object.entries(filters).forEach(([k, v]) => {
      state.filters[k] = v;
    });
  },
  SET_COMMENT_USERS_VOTES(state, { users, commentId }) {
    state.commentUserLikes[commentId] = users;
  },
  SET_USER_LIKED_COMMENTS(state, { commentsId = [] }) {
    state.userLikedCommentIds = commentsId;
  }
};

export default mutations;